import { ActionReducer, MetaReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { AppState } from '.';

export const bigintReplacer = (_: unknown, value: unknown): unknown => {
  return typeof value === 'bigint' ? value.toString() : value;
};

function configureKeysWithReplacer(keys: string[]): Record<string, unknown>[] {
  return keys.map((key) => ({
    [key]: {
      replacer: bigintReplacer,
    },
  }));
}

const stateKeysToSync = ['auth', 'cart', 'checkout', 'orderType', 'deliveryZone', 'client'];

export function storageReducer(
  reducer: ActionReducer<AppState>
): ActionReducer<AppState> {
  return localStorageSync({
    keys: configureKeysWithReplacer(stateKeysToSync),
    rehydrate: true, // Rehidrata el estado al cargar la app
  })(reducer);
}

export const metaReducers: MetaReducer<AppState>[] = [storageReducer];
